var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEgg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 432,
    viewBox: "0 0 433 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.264 378.773C237.604 449.434 123.39 449.783 53.1613 379.554C-17.0677 309.325 -16.7182 195.112 53.9419 124.452C124.602 53.7914 338.325 -46.0681 408.554 24.1609C478.783 94.3899 378.924 308.113 308.264 378.773Z",
    fill: "#F7F6EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEgg9);
export default __webpack_public_path__ + "static/media/background-egg-9.a138dc0529635b2897aefc999841b943.svg";
export { ForwardRef as ReactComponent };